"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositCancel = exports.WithdrawalIsAccepted = exports.Wheel = exports.Welcome = exports.VipWheel = exports.SignUp = exports.ProfileMenu = exports.LogIn = exports.LevelUp = exports.GameInfo = exports.ForgotPasswordByPhone = exports.ForgotPassword = exports.DepositSuccess = exports.DepositStatus = exports.Deposit = exports.DailyDigest = exports.CashBonusPopup = exports.AddCurrency = void 0;
var dynamic_1 = __importDefault(require("next/dynamic"));
var SignUp = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/SignUp')); }); });
exports.SignUp = SignUp;
var LogIn = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/LogIn')); }); });
exports.LogIn = LogIn;
var Welcome = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/Welcome')); }); });
exports.Welcome = Welcome;
var AddCurrency = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/AddCurrency')); }); });
exports.AddCurrency = AddCurrency;
var GameInfo = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/GameInfo')); }); });
exports.GameInfo = GameInfo;
var DailyDigest = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/DailyDigest')); }); });
exports.DailyDigest = DailyDigest;
var LevelUp = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/LevelUp')); }); });
exports.LevelUp = LevelUp;
var CashBonusPopup = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/CashBonusPopup')); }); });
exports.CashBonusPopup = CashBonusPopup;
var ForgotPassword = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/ForgotPassword')); }); });
exports.ForgotPassword = ForgotPassword;
var ForgotPasswordByPhone = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/ForgotPasswordByPhone')); }); });
exports.ForgotPasswordByPhone = ForgotPasswordByPhone;
var WithdrawalIsAccepted = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/WithdrawalIsAccepted')); }); });
exports.WithdrawalIsAccepted = WithdrawalIsAccepted;
var ProfileMenu = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/ProfileMenu')); }); });
exports.ProfileMenu = ProfileMenu;
var DepositStatus = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/DepositStatus')); }); });
exports.DepositStatus = DepositStatus;
var DepositCancel = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/DepositCancel')); }); });
exports.DepositCancel = DepositCancel;
var DepositSuccess = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/DepositSuccess')); }); });
exports.DepositSuccess = DepositSuccess;
var Deposit = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/Deposit')); }); });
exports.Deposit = Deposit;
var Wheel = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/Wheel')); }); });
exports.Wheel = Wheel;
var VipWheel = (0, dynamic_1.default)(function () { return Promise.resolve().then(function () { return __importStar(require('../classic/VipWheel')); }); });
exports.VipWheel = VipWheel;
